<template>
  <div class="col-md-3 col-sm-12 col-xs-12">
    <q-select
      dense
      outlined
      v-model="responsavel"
      use-input
      input-debounce="800"
      option-label="nome"
      option-value="id"
      @input-value="setModel"
      behavior="menu"
      hide-selected
      label="Selecione o Requisitante"
      label-color="grey-6"
      fill-input
      :disable="disable"
      class="select"
      :options="listaResponsaveis"
      @filter="filterFn"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhum colaborador encontrado.
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { usuarioTemPermissao } from "../../../helpers/permissaoHelper";

export default {
  name: "SelectComponentResponsaveis",
  emits: ["emitirFuncionario"],
  props: [
    "resetar",
    "model",
    "atualizarDados",
    "disable",
    "deletado",
    "isSingle",
    "buscarPorCracha",
    "vendorId",
  ],

  setup(props, { emit }) {
    const store = useStore();

    const responsavel = ref(props.model);
    const listaResponsaveis = ref([]);
    const paginacao = ref({
      page: 1,
      rowsPerPage: 10,
    });

    // se tiver permissão de ver todos usuários, não filtra por vendor_id
    const temPermissaoTodosUsuarios = computed(() =>
      usuarioTemPermissao(store, "visualizar_todos_usuários")
    );

    const listarFuncionarios = async (search) => {
      listaResponsaveis.value = [];
      try {
        const vendorId = temPermissaoTodosUsuarios.value
          ? undefined
          : props.vendorId || store.state.org.unidadeData?.id || undefined;

        const response = await store.dispatch(
          "ferramentaria/listarFuncionarios",
          {
            vendor_id: vendorId,
            per_page: 10,
            page: 1,
            search: search,
            deleted: props.deletado ? props.deletado : undefined,
          }
        );

        if (response.funcionarios.length > 0) {
          listaResponsaveis.value = response.funcionarios;

          if (response.funcionarios.length === 1 && !props.isSingle) {
            responsavel.value = {
              ...listaResponsaveis.value[0],
              tipo: "geral",
            };
          }

          return;
        }
        listaResponsaveis.value = [];
      } catch (error) {
        console.error(error);
      }
    };

    const listarFuncionariosPorCracha = async (card_id) => {
      listaResponsaveis.value = [];
      try {
        const vendorId = temPermissaoTodosUsuarios.value
          ? undefined
          : props.vendorId || store.state.org.unidadeData?.id || undefined;

        const response = await store.dispatch(
          "ferramentaria/listarFuncionarios",
          {
            vendor_id: vendorId,
            per_page: 10,
            page: 1,
            card_id: card_id,
            deleted: props.deletado ? props.deletado : undefined,
          }
        );

        if (response.funcionarios.length > 0) {
          listaResponsaveis.value = response.funcionarios;

          if (response.funcionarios.length === 1) {
            responsavel.value = {
              ...listaResponsaveis.value[0],
              tipo: "geral",
            };
          }

          return;
        }
        listaResponsaveis.value = [];
      } catch (error) {
        console.error(error);
      }
    };

    const listarFuncionarioEspecifico = async (val) => {
      listaResponsaveis.value = [];
      try {
        const vendorId = temPermissaoTodosUsuarios.value
          ? undefined
          : props.vendorId || store.state.org.unidadeData?.id || undefined;

        const response = await store.dispatch(
          "ferramentaria/listarFuncionarios",
          {
            vendor_id: vendorId,
            per_page: 10,
            page: 1,
            search: val.nome,
          }
        );
        listaResponsaveis.value = response.funcionarios;
        listaResponsaveis.value = listaResponsaveis.value.filter(
          (funcionario) => funcionario.id === val.id
        );
        responsavel.value = listaResponsaveis.value[0];
        emitirFuncionario(responsavel.value);
      } catch (error) {
        console.error(error);
      }
    };

    watch(
      () => responsavel.value,
      () => {
        if (
          responsavel.value == "" &&
          responsavel.value == undefined &&
          responsavel.value == null
        ) {
          return;
        }

        emitirFuncionario(responsavel.value);
      }
    );

    watch(
      () => props.resetar,
      () => {
        responsavel.value = "";
        listaResponsaveis.value = [];
      }
    );

    watch(
      () => props.atualizarDados,
      () => {
        listarFuncionarioEspecifico(responsavel.value);
      }
    );

    watch(
      () => props.model,
      () => {
        responsavel.value = props.model;
      }
    );

    let emitirFuncionario = async (emitirFuncionario, unidade) => {
      emit("emitirFuncionario", emitirFuncionario, unidade);
    };

    return {
      listaResponsaveis,
      listarFuncionarios,
      responsavel,
      emitirFuncionario,
      listarFuncionarioEspecifico,
      paginacao,
      setModel(val) {
        if (val === "") {
          responsavel.value = val;
        }
      },
      filterFn(val, update) {
        if (props.buscarPorCracha) {
          listarFuncionariosPorCracha(val)
            .then(() => {
              update();
            })
            .catch((error) => {
              console.error("Erro no filterFn:", error);
              update();
            });
        } else {
          listarFuncionarios(val);
          setTimeout(() => {
            update();
          }, 500);
        }
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .select {
    font-size: 12px;
  }
}
</style>
